import React from 'react';
import './Stepper.scss';
import uid from '../../../../utils/functions/uid';

function Stepper({ steps = 0, activeStep = 1, setActiveStep }) {
  const handleStepClick = (step) => {
    if (typeof setActiveStep === 'function' && activeStep > step) {
      setActiveStep(step);
    }
  };
  return (
    <div className="steps flex">
      {Array(steps)
        .fill(null)
        .map((_, index) => (
          // eslint-disable-next-line max-len
          // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
          <div
            onClick={() => handleStepClick(index + 1)}
            key={uid()}
            className={`step ${activeStep === index + 1 && 'active'} cursor-pointer`}
          >
            {index + 1}
          </div>
        ))}
    </div>
  );
}

export default Stepper;
